(ns journal-app-client.components.icon
  (:require [reagent.core :as r]))

(defn icon [& [props]]
  (let [size (or (:size props) (:size (:style props)))]
    (into
      [(if (:on-click props) :button.is-clickable.icon :span.icon)
       (merge
         (when (map? props) (dissoc props :size))
         {:style (merge
                   {:font-size size
                    :height size
                    :width size}
                   (dissoc (:style props) :size))})]
      (r/children (r/current-component)))))

(defn angle-down [& [props]]
  (let [active? (or (:active? props) (:is-active? props))]
    [icon
     (dissoc props :icon-class :is-active? :active?)
     [:i.fas.fa-angle-down
      {:class (or (:icon-class props) "fas fa-angle-down")
       :style {:transform (when active? "rotate(0)" "rotate(180deg)")
               :transition "transform var(--transition-duration) ease"}}]]))

(defn flag-class [{:keys [country-code language-code flag-type]}]
  (let [country-code (if (keyword? country-code)
                       (name country-code)
                       country-code)]
    (if country-code
      (if (or (= flag-type "1x1") (= flag-type "square"))
        (str "flag-icon flag-icon-" country-code " flag-icon-squared")
        (str "flag-icon flag-icon-" country-code))
      "fas fa-globe-europe")))

(def emoji-list
  {:emoticons [
               "twa-grinning-face"
               "twa-grinning-face-with-big-eyes"
               "twa-grinning-face-with-smiling-eyes"
               "twa-beaming-face-with-smiling-eyes"
               "twa-grinning-squinting-face"
               "twa-grinning-face-with-sweat"
               "twa-rolling-on-the-floor-laughing"
               "twa-face-with-tears-of-joy"
               "twa-slightly-smiling-face"
               "twa-upside-down-face"
               "twa-winking-face"
               "twa-smiling-face-with-smiling-eyes"
               "twa-smiling-face-with-halo"
               "twa-smiling-face-with-hearts"
               "twa-smiling-face-with-heart-eyes"
               "twa-star-struck"
               "twa-face-blowing-a-kiss"
               "twa-kissing-face"
               "twa-smiling-face"
               "twa-kissing-face-with-closed-eyes"
               "twa-kissing-face-with-smiling-eyes"
               "twa-smiling-face-with-tear"
               "twa-face-savoring-food"
               "twa-face-with-tongue"
               "twa-winking-face-with-tongue"
               "twa-zany-face"
               "twa-squinting-face-with-tongue"
               "twa-money-mouth-face"
               "twa-hugging-face"
               "twa-face-with-hand-over-mouth"
               "twa-shushing-face"
               "twa-thinking-face"
               "twa-zipper-mouth-face"
               "twa-face-with-raised-eyebrow"
               "twa-neutral-face"
               "twa-expressionless-face"
               "twa-face-without-mouth"
               "twa-smirking-face"
               "twa-unamused-face"
               "twa-face-with-rolling-eyes"
               "twa-grimacing-face"
               "twa-lying-face"
               "twa-relieved-face"
               "twa-pensive-face"
               "twa-sleepy-face"
               "twa-drooling-face"
               "twa-sleeping-face"
               "twa-face-with-medical-mask"
               "twa-face-with-thermometer"
               "twa-face-with-head-bandage"
               "twa-nauseated-face"
               "twa-face-vomiting"
               "twa-sneezing-face"
               "twa-hot-face"
               "twa-cold-face"
               "twa-woozy-face"
               "twa-dizzy-face"
               "twa-exploding-head"
               "twa-cowboy-hat-face"
               "twa-partying-face"
               "twa-disguised-face"
               "twa-smiling-face-with-sunglasses"
               "twa-nerd-face"
               "twa-face-with-monocle"
               "twa-confused-face"
               "twa-worried-face"
               "twa-slightly-frowning-face"
               "twa-frowning-face"
               "twa-face-with-open-mouth"
               "twa-hushed-face"
               "twa-astonished-face"
               "twa-flushed-face"
               "twa-pleading-face"
               "twa-frowning-face-with-open-mouth"
               "twa-anguished-face"
               "twa-fearful-face"
               "twa-anxious-face-with-sweat"
               "twa-sad-but-relieved-face"
               "twa-crying-face"
               "twa-loudly-crying-face"
               "twa-face-screaming-in-fear"
               "twa-confounded-face"
               "twa-persevering-face"
               "twa-disappointed-face"
               "twa-downcast-face-with-sweat"
               "twa-weary-face"
               "twa-tired-face"
               "twa-yawning-face"
               "twa-face-with-steam-from-nose"
               "twa-pouting-face"
               "twa-angry-face"
               "twa-face-with-symbols-on-mouth"
               "twa-smiling-face-with-horns"
               "twa-angry-face-with-horns"
               "twa-skull"
               "twa-skull-and-crossbones"
               "twa-pile-of-poo"
               "twa-clown-face"
               "twa-ogre"
               "twa-goblin"
               "twa-ghost"
               "twa-alien"
               "twa-alien-monster"
               "twa-robot"
               "twa-grinning-cat"
               "twa-grinning-cat-with-smiling-eyes"
               "twa-cat-with-tears-of-joy"
               "twa-smiling-cat-with-heart-eyes"
               "twa-cat-with-wry-smile"
               "twa-kissing-cat"
               "twa-weary-cat"
               "twa-crying-cat"
               "twa-pouting-cat"
               "twa-see-no-evil-monkey"
               "twa-hear-no-evil-monkey"
               "twa-speak-no-evil-monkey"
               "twa-kiss-mark"
               "twa-love-letter"
               "twa-heart-with-arrow"
               "twa-heart-with-ribbon"
               "twa-sparkling-heart"
               "twa-growing-heart"
               "twa-beating-heart"
               "twa-revolving-hearts"
               "twa-two-hearts"
               "twa-heart-decoration"
               "twa-heart-exclamation"
               "twa-broken-heart"
               "twa-red-heart"
               "twa-orange-heart"
               "twa-yellow-heart"
               "twa-green-heart"
               "twa-blue-heart"
               "twa-purple-heart"
               "twa-brown-heart"
               "twa-black-heart"
               "twa-white-heart"
               "twa-hundred-points"
               "twa-anger-symbol"
               "twa-collision"
               "twa-dizzy"
               "twa-sweat-droplets"
               "twa-dashing-away"]})